<template>
  <v-container fluid class="pa-2 pa-md-6">
    <div class="text-h5 text-center mb-4">Trazabilidades de obrador</div>

    <v-row class="mb-3" align="center" justify="space-between">
      <v-col cols="12" sm="6" md="3">
        <v-text-field
          v-model="filtros.batch"
          label="Lote"
          dense
          clearable
          @keyup.enter="loadData"
        />
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-autocomplete
          :items="articles"
          item-text="Name"
          item-value="Id"
          v-model="filtros.articulo"
          label="Artículo"
          dense
          clearable
          prepend-icon="mdi-cube-outline"
          no-data-text="No hay artículos"
          @change="loadData"
        />
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-menu
          v-model="menuDesde"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="filtros.fechaDesde"
              label="Fecha desde"
              dense
              readonly
              clearable
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker v-model="filtros.fechaDesde" @input="menuDesde = false" />
        </v-menu>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-menu
          v-model="menuHasta"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="filtros.fechaHasta"
              label="Fecha hasta"
              dense
              readonly
              clearable
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker v-model="filtros.fechaHasta" @input="menuHasta = false" />
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="2">
        <v-select
          v-model="filtros.estado"
          :items="estados"
          item-text="text"
          item-value="value"
          label="Estado"
          dense
          clearable
          @change="loadData"
        />
      </v-col>

      <v-col cols="12" sm="6" md="3" class="text-right">
        <v-btn color="primary" class="mr-2" small @click="loadData" :loading="loading">
          FILTRAR
        </v-btn>
        <v-btn color="success" small @click="goCreate">
          Nueva
        </v-btn>
      </v-col>

      <v-btn color="info" small class="mr-2" @click="openPolaresDialog">
        CONSULTAR POLARES
      </v-btn>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="rows"
      :loading="loading"
      class="elevation-1"
      dense
      mobile-breakpoint="0"
    >
      <template v-slot:item.Fecha="{ item }">
        {{ formatDate(item.Fecha) }}
      </template>

      <template v-slot:item.CantidadTotalFabricada="{ item }">
        {{ formatNumber(item.CantidadTotalFabricada) }}
      </template>

      <template v-slot:item.Estado="{ item }">
        <v-chip small :color="estadoColor(item.Estado)" dark>
          {{ estadoTexto(item.Estado) }}
        </v-chip>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn
          small
          icon
          color="primary"
          title="Editar"
          @click="editItem(item)"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          v-if="(Number(perId) === 10634 || Number(perId) === 3 || Number(perId) === 56487 || Number(perId) === 56458) && item.Estado !== 'ARCHIVADO'"
          small
          icon
          color="green"
          title="Archivar trazabilidad"
          @click="validarItem(item)"
        >    
          <v-icon>mdi-check-decagram</v-icon>
        </v-btn>

        <v-btn
          v-if="(Number(perId) === 10634 ||
                Number(perId) === 3 ||
                Number(perId) === 56487 ||
                Number(perId) === 56458) &&
                item.Estado === 'ARCHIVADO'"
          small
          icon
          color="orange"
          title="Desarchivar trazabilidad"
          @click="desarchivarItem(item)"
        >
          <v-icon>mdi-archive-arrow-up</v-icon>
        </v-btn>

        <v-btn
          v-if="puedeEliminarTrazabilidad"
          small
          icon
          color="red"
          title="Eliminar trazabilidad"
          @click="deleteItem(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>

      <template v-slot:no-data>
        <div class="pa-4 text-center grey--text">
          No hay trazabilidades guardadas
        </div>
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" top timeout="2500">
      {{ snackbar.text }}
    </v-snackbar>

    <v-dialog v-model="polaresDialog" max-width="850">
      <v-card>
        <v-card-title class="text-h6">
          Consulta de polares
        </v-card-title>

        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="6">
              <v-select
                :items="freidoras"
                v-model="polaresFiltro.fila"
                label="Freidora / zona"
                dense
                outlined
                @change="loadPolares"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-menu
                v-model="menuMesPolares"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="polaresFiltro.mes"
                    label="Mes"
                    dense
                    outlined
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>

                <v-date-picker
                  v-model="polaresFiltro.mes"
                  type="month"
                  @input="menuMesPolares = false; loadPolares();"
                />
              </v-menu>
            </v-col>
          </v-row>

          <v-data-table
            :headers="polaresHeaders"
            :items="polaresRows"
            :loading="loadingPolares"
            dense
            class="elevation-1 mt-3"
          >
            <template v-slot:item.Fecha="{ item }">
              {{ formatDate(item.Fecha) }}
            </template>

            <template v-slot:item.PolaresInicio="{ item }">
              {{ formatNumber(item.PolaresInicio) }}
            </template>

            <template v-slot:item.PolaresFinal="{ item }">
              {{ formatNumber(item.PolaresFinal) }}
            </template>
            <template v-slot:item.CambioAceite="{ item }">
              <v-chip
                small
                :color="item.CambioAceite ? 'green' : 'grey'"
                dark
              >
                {{ item.CambioAceite ? 'Sí' : 'No' }}
              </v-chip>
            </template>

            <template v-slot:no-data>
              <div class="pa-4 text-center grey--text">
                No hay registros de polares para esta selección
              </div>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey darken-1" @click="polaresDialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "TrazabilidadObradorListado",
  computed: {
    ...mapState(["urlRaiz", "perId"]),

    puedeEliminarTrazabilidad() {
      return [56487, 56458, 3, 10634].includes(Number(this.perId));
    },
    puedeArchivarTrazabilidad() {
      return [56487, 56458, 3, 10634].includes(Number(this.perId));
    }
  },
  data() {
    return {
      loading: false,
      rows: [],
      menuDesde: false,
      menuHasta: false,
      articles: [],
      filtros: {
        batch: "",
        fechaDesde: null,
        fechaHasta: null,
        articulo: null
      },
      estados: [
        { text: "En curso", value: "EN_CURSO" },
        { text: "Finalizado", value: "FINALIZADO" },
        { text: "Archivado", value: "ARCHIVADO" }
      ],
      headers: [
        { text: "Fecha", value: "Fecha", width: 130 },
        { text: "Lote", value: "Lote", width: 180 },
        { text: "Artículo", value: "ArticuloNombre" },
        { text: "Persona", value: "PersonaNombre" },
        { text: "Cantidad total", value: "CantidadTotalFabricada", width: 140 },
        { text: "Estado", value: "Estado", width: 130 },
        { text: "", value: "actions", width: 120, sortable: false }
      ],
      snackbar: {
        visible: false,
        color: "",
        text: ""
      },
      polaresDialog: false,
      loadingPolares: false,
      menuMesPolares: false,
      polaresRows: [],
      freidoras: [
        "Freidora en continuo",
        "Balsa 1",
        "Balsa 2"
      ],
      polaresFiltro: {
        fila: "Freidora en continuo",
        mes: new Date().toISOString().substr(0, 7)
      },
      polaresHeaders: [
        { text: "Día", value: "Fecha", width: 140 },
        { text: "Polares de inicio", value: "PolaresInicio", align: "right" },
        { text: "Polares de fin", value: "PolaresFinal", align: "right" },
        { text: "Cambio aceite", value: "CambioAceite", align: "center" }

      ],
    };
  },
  mounted() {
    this.loadArticles();
    this.loadData();
  },
  methods: {

    desarchivarItem(item) {
      if (!this.puedeArchivarTrazabilidad) {
        this.toast("No tienes permiso para desarchivar trazabilidades", "error");
        return;
      }

      if (!confirm("¿Seguro que quieres desarchivar esta trazabilidad?")) {
        return;
      }

      this.loading = true;

      axios.post(
        `${this.urlRaiz}/api/ztrazabilidadobrador/changeStatus`,
        {
          trazabilidadObradorId: item.TrazabilidadObradorId,
          estado: "FINALIZADO"
        },
        {
          headers: this.auth()
        }
      )
      .then(() => {
        this.toast("Trazabilidad desarchivada correctamente");
        this.loadData();
      })
      .catch(() => {
        this.toast("Error al desarchivar la trazabilidad", "error");
      })
      .finally(() => {
        this.loading = false;
      });
    },

    validarItem(item) {
      if (!confirm("¿Seguro que quieres marcar esta trazabilidad como archivada?")) {
        return;
      }

      this.loading = true;

      axios.post(
        `${this.urlRaiz}/api/ztrazabilidadobrador/changeStatus`,
        {
          trazabilidadObradorId: item.TrazabilidadObradorId,
          estado: "ARCHIVADO"
        },
        {
          headers: this.auth()
        }
      )
      .then(() => {
        this.toast("Trazabilidad validada correctamente");
        this.loadData();
      })
      .catch(() => {
        this.toast("Error al archivar la trazabilidad", "error");
      })
      .finally(() => {
        this.loading = false;
      });
    },
    estadoTexto(estado) {
      switch (estado) {
        case "EN_CURSO": return "En curso";
        case "FINALIZADO": return "Finalizado";
        case "ARCHIVADO": return "Archivado";
        default: return estado || "";
      }
    },
    estadoColor(estado) {
      switch (estado) {
        case "EN_CURSO": return "orange";
        case "FINALIZADO": return "blue";
        case "ARCHIVADO": return "green";
        default: return "grey";
      }
    },
    async loadArticles() {
      try {
        const res = await axios.get(`${this.urlRaiz}/api/ztrazabilidadobrador/articles`, {
          headers: this.auth(),
          params: null
        });

        this.articles = res.data || [];
      } catch (e) {
        console.error(e);
        this.toast("Error al cargar artículos", "error");
      }
    },
    auth() {
      const t = localStorage.getItem("token");
      return { Authorization: t };
    },
    toast(text, type = "success") {
      this.snackbar.text = text;
      this.snackbar.color = type === "error" ? "red darken-2" : "green darken-2";
      this.snackbar.visible = true;
    },
    formatDate(v) {
      if (!v) return "";
      const d = new Date(v);
      if (isNaN(d.getTime())) return v;
      return d.toLocaleDateString("es-ES");
    },
    formatNumber(v) {
      if (v === null || v === undefined || v === "") return "";
      return new Intl.NumberFormat("es-ES", { maximumFractionDigits: 3 }).format(Number(v));
    },
    loadData() {
      this.loading = true;

      axios.get(`${this.urlRaiz}/api/ztrazabilidadobrador/list`, {
        params: {
          batch: this.filtros.batch,
          articulo: this.filtros.articulo,
          fechaDesde: this.filtros.fechaDesde,
          fechaHasta: this.filtros.fechaHasta,
          Estado: this.filtros.estado
        },
        headers: this.auth()
      })
      .then(res => {
        this.rows = res.data || [];
      })
      .catch(() => this.toast("Error al cargar las trazabilidades", "error"))
      .finally(() => {
        this.loading = false;
      });
    },
    goCreate() {
      this.$router.push({ name: "trazabilidad-obrador" });
    },
    editItem(item) {
      this.$router.push({
        name: "trazabilidad-obrador",
        query: { id: item.TrazabilidadObradorId }
      });
    },

    deleteItem(item) {
      if (!this.puedeEliminarTrazabilidad) {
        this.toast("No tienes permiso para eliminar trazabilidades", "error");
        return;
      }

      if (!confirm(`¿Seguro que quieres eliminar la trazabilidad del lote ${item.Lote || ""}?`)) {
        return;
      }

      this.loading = true;

      axios.delete(
        `${this.urlRaiz}/api/ztrazabilidadobrador/${item.TrazabilidadObradorId}`,
        {
          headers: this.auth()
        }
      )
      .then(() => {
        this.toast("Trazabilidad eliminada correctamente");
        this.loadData();
      })
      .catch(() => {
        this.toast("Error al eliminar la trazabilidad", "error");
      })
      .finally(() => {
        this.loading = false;
      });
    },

    openPolaresDialog() {
      this.polaresDialog = true;
      this.loadPolares();
    },

    loadPolares() {
      if (!this.polaresFiltro.fila || !this.polaresFiltro.mes) return;

      this.loadingPolares = true;

      axios.get(`${this.urlRaiz}/api/ztrazabilidadobrador/polares`, {
        params: {
          fila: this.polaresFiltro.fila,
          mes: this.polaresFiltro.mes
        },
        headers: this.auth()
      })
      .then(res => {
        this.polaresRows = res.data || [];
      })
      .catch(() => {
        this.toast("Error al cargar la consulta de polares", "error");
      })
      .finally(() => {
        this.loadingPolares = false;
      });
    },
  }
};
</script>